<template>
  <v-container fluid>
      <v-card>
          <v-toolbar dense color="#96298A" dark>
              <v-toolbar-title>Reporte Nacional</v-toolbar-title>
              <v-divider class="mx-4" vertical></v-divider>
              <v-btn color="#FC8333" text outlined @click="showParams = !showParams">
                  <div v-if="!showParams">Ver Parametros <v-icon>mdi-arrow-right</v-icon></div>
                  <div v-else>Ocultar Parametros <v-icon>mdi-arrow-left</v-icon></div>
               </v-btn>
               <v-divider class="mx-4" vertical></v-divider>
               <v-spacer></v-spacer>
               <v-toolbar-items>
                   <v-divider class="mx-4" vertical></v-divider>
                  <v-text-field
                    v-model="searcher"
                    append-icon="mdi-file-search"
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                    max-width="200px"
                    ></v-text-field>
                  <v-divider vertical class="mx-4"></v-divider>
                   <v-select
                        v-model="selectedHeaders"
                        label="Campos del Reporte"
                        :items="headers"
                        append-icon="mdi-format-columns"
                        return-object
                        clearable
                        filled
                        multiple
                    >
                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index < 2" x-small color="#FC8333" text-color="black">
                                <span>{{ item.text }}</span>
                            </v-chip>
                            <span v-if="index === 2" class="grey--text caption">(+{{ selectedHeaders.length - 2 }} otros)</span>
                        </template>
                    </v-select>
                    <v-divider class="mx-4" vertical></v-divider>
                    <v-btn icon x-large @click="exportToExcel()"><v-icon>mdi-microsoft-excel</v-icon></v-btn>
                    <v-divider class="mx-4" vertical></v-divider>
               </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row>
                <v-col cols="12" sm="12" md="3" v-if="showParams">
                    <v-card>
                        <v-card-subtitle>Parametros</v-card-subtitle>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="desde" type="date" clearable label="Desde"></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="hasta" type="date" clearable label="Hasta"></v-text-field>
                                </v-col>
                            </v-row>
                        <v-row>
                            <v-col>
                                <v-combobox
                                    v-model="ciudadO"
                                    label="Ciudad Origen"
                                    :items="ciudades"
                                    append-icon="mdi-map-marker"
                                    item-value="ciudad"
                                    item-text="ciudad"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-combobox
                                    v-model="ciudadD"
                                    label="Ciudad Destino"
                                    :items="ciudades"
                                    append-icon="mdi-map-marker"
                                    item-value="ciudad"
                                    item-text="ciudad"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-combobox
                                    v-model="estatus"
                                    label="Estatus"
                                    :items="estatuses"
                                    append-icon="mdi-sticker-check"
                                    item-value="id"
                                    item-text="descripcion"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-combobox
                                    v-model="agente"
                                    label="Agentes"
                                    :items="agentes"
                                    append-icon="mdi-handshake"
                                    item-value="id"
                                    item-text="nombre"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-combobox
                                    v-model="pendfin"
                                    label="Pendientes / Finalizadas"
                                    :items="pendfines"
                                    append-icon="mdi-playlist-check"
                                    item-value="cod"
                                    item-text="descripcion"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" dark outlined @click="getData()">Generar <v-icon>mdi-file</v-icon></v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" :md="showParams ? '9' : '12'">
                    <v-card>
                        <v-card-subtitle>Reporte</v-card-subtitle>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-data-table :headers="showHeaders" :items="guias" :search="searcher">
                                        <template v-slot:item.direccion_c="{ item }">
                                            {{item.direccion1_c + ' ' + item.direccion2_c + ' ' + (item.direccion3_c != null ? item.direccion3_c : '')}}
                                        </template>
                                        <template v-slot:item.direccion_e="{ item }">
                                            {{item.direccion1_e + ' ' + item.direccion2_e + ' ' + (item.direccion3_e != null ? item.direccion3_e : '')}}
                                        </template>
                                        <template v-slot:item.created_at="{ item }">
                                            {{formatDate(item.created_at)}}
                                        </template>
                                        <template v-slot:item.fecha_estatus="{ item }">
                                          {{
                                            item.ultimoestatus != null
                                              ? formatDate(
                                                  item.ultimoestatus.fecha + 'T00:00:00Z'
                                                )
                                              : null
                                          }}
                                        </template>
                                        <template v-slot:item.ultimo_estatus="{ item }">
                                          {{
                                            item.ultimoestatus != null
                                              ? item.ultimoestatus.estatus.descripcion
                                              : null
                                          }}
                                        </template>
                                        <template v-slot:item.comentario_estatus="{ item }">
                                          {{
                                            item.ultimoestatus != null
                                              ? item.ultimoestatus.comentarios
                                              : null
                                          }}
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
          </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import apicon from '../plugins/apicon'
import utils from '../utils/utils'
const XLSX = require('xlsx')
export default {
created: function(){},
data() {
    return{
        showParams: true,
        desde: null,
        hasta: null,
        searcher: null,
        estatuses: [],
        estatus: null,
        agentes: [],
        agente: null,
        pendfines: [
            {descripcion: 'Pendientes', cod: 'P'},
            {descripcion: 'Finalizadas', cod: 'F'},
        ],
        pendfin: null,
        ciudades: [],
        ciudadO: null,
        ciudadD: null,
        guias: [],
        headers: [
            { text: "Fecha", value: "created_at", sortable: false },
            { text: "Guía", value: "guia_interna", sortable: false },
            { text: "Guía Alterna", value: "guia_proveedor", sortable: false },
            { text: "Agente", value: "proveedor", sortable: false },
            { text: "Origen", value: "ciudad_e", sortable: false },
            { text: "Destino", value: "ciudad_c", sortable: false },
            { text: "Dirección Destino", value: "direccion_c", sortable: false },
            { text: "Tipo Envío", value: "tipo", sortable: false },
            { text: "Piezas", value: "piezas", sortable: false },
            { text: "Peso (kgs)", value: "peso", sortable: false },
            { text: "Volumen (kgs)", value: "volumen", sortable: false },
            { text: "Remitente", value: "empresa_e", sortable: false },
            { text: "Destinatario", value: "empresa_c", sortable: false },
            { text: "Observacion", value: "observaciones", sortable: false },
            { text: "Estatus", value: "ultimo_estatus", sortable: false },
            { text: "Fecha Estatus", value: "fecha_estatus", sortable: false },
            {
              text: "Comentario Estatus",
              value: "comentario_estatus",
              sortable: false,
            },
            { text: "POD Fecha", value: "podfecha", sortable: false },
            { text: "POD Hora", value: "podhora", sortable: false },
            { text: "POD Nombre", value: "podnombre", sortable: false },
            { text: "Referencia1", value: "referencia1", sortable: false },
            { text: "Referencia2", value: "referencia2", sortable: false },
            { text: "Referencia3", value: "referencia3", sortable: false },
        ],
        selectedHeaders: [],
        isCliente: false,
    }
},
methods:{
    getEstatuses: function(){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'estatusall').then((result) => {
            this.estatuses = result
        }).catch((err) => {
            console.log(err);
        })
    },
    getAgentes: function(){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'agente').then((result) => {
            this.agentes = result;
            //this.agentes.push({id: 0, nombre: 'DHL'});
            //this.agentes.push({id: 1000, nombre: 'UPS'});
            this.agentes.push({id: 1001, nombre: 'Vinculados'});
            this.agentes.push({id: 1002, nombre: 'No Vinculados'});
        }).catch((err) => {
            console.log(err);
        })
    },
    getCiudades: function(){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'ciudadesec').then((result) => {
            this.ciudades = result;
        }).catch((err) =>{
            console.log(err);
        })
    },
    getData: function(){
        apicon.saveDataApi(apicon.getApiBaseUrl() + 'reportegeneral',{
            desde: this.desde,
            hasta : this.hasta,
            tipo: 'nacional',
            ciudadO: this.ciudadO != null ? this.ciudadO.ciudad : null,
            ciudadD: this.ciudadD != null ? this.ciudadD.ciudad : null,
            estatus: this.estatus != null ? this.estatus.id : null,
            agente: this.agente != null ? this.agente.nombre : null,
            pendifn: this.pendfin != null ? this.pendfin.cod : null,
            }).then((result) => {
            this.guias = result;
            this.showParams = false;
        }).catch((err) => {
            console.log(err);
        });
    },
    formatDate: function(date){
        return utils.formatDate(date)
    },
    exportToExcel: function(){
        //Map Data to new Json
        let newJson = this.guias.map(rec => {
            let obj = {
                'Fecha' :  new Date (new Date(rec.created_at).toISOString().substring(0,10) + 'T00:00:00'),
                "Guía": rec.guia_interna,
                "Guía Alterna": rec.guia_proveedor,
                "Agente": rec.proveedor,
                "Origen": rec.ciudad_e,
                "Destino": rec.ciudad_c,
                "Dirección Destino": rec.direccion1_c + ' ' + rec.direccion2_c + ' ' + (rec.direccion3_c != null ? rec.direccion3_c : ''),
                "Tipo Envío": rec.tipo,
                "Piezas": rec.piezas,
                "Peso (kgs)": rec.peso,
                "Volumen (kgs)": rec.volumen,
                "Remitente": rec.empresa_e,
                "Destinatario": rec.empresa_c,
                "Observación": rec.observaciones,
                "Estatus": rec.ultimoestatus != null
                            ? rec.ultimoestatus.estatus.descripcion
                            : null,
                "Fecha Estatus":
                          rec.ultimoestatus != null
                            ?
                            this.formatDate(rec.ultimoestatus.fecha + 'T00:00:00Z')
                            : null
                        ,
                "Comentario Estatus":  rec.ultimoestatus != null
                            ? rec.ultimoestatus.comentarios
                            : null,
                "POD Fecha": rec.podfecha,
                "POD Hora": rec.podhora,
                "POD Nombre": rec.podnombre,
                "Referencia1": rec.referencia1,
                "Referencia2": rec.referencia2,
                "Referencia3": rec.referencia3,
            }
            //Eliminar las columnas no seleccionadas
            Object.keys(obj).forEach((key) => {
                const found = this.selectedHeaders.some(el => el.text === key);
                if(!found){
                    delete obj[key]
                }
            })
            return obj;
        });
        let data = XLSX.utils.json_to_sheet(newJson,{origin: "A7"});
        const workbook = XLSX.utils.book_new();
        const filename = 'Reporte Nacional';
        //Fit columns
        const wscols = utils.getAutoFitColumns(newJson);
        data["!cols"] = wscols;
        XLSX.utils.book_append_sheet(workbook, data, filename);

        var ws = workbook.Sheets[workbook.SheetNames[0]];
        XLSX.utils.sheet_add_aoa(ws,[["REPORTE NACIONAL"]], {origin: "A1"});
        XLSX.utils.sheet_add_aoa(ws,[["ORIGEN: " + (this.ciudadO != null ? this.ciudadO.ciudad : 'TODOS')]], {origin: "A2"});
        XLSX.utils.sheet_add_aoa(ws,[["DESTINO: " + (this.ciudadD != null ? this.ciudadD.ciudad : 'TODOS')]], {origin: "A3"});
        XLSX.utils.sheet_add_aoa(ws,[["ESTATUS: " + (this.estatus != null ? this.estatus.descripcion : 'TODOS')]], {origin: "A4"});
        XLSX.utils.sheet_add_aoa(ws,[["FECHA: " + this.desde + " AL " + this.hasta]], {origin: "A5"});

        XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
},
computed:{
    showHeaders () {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
},
mounted: function(){
    apicon.setAuthHeaders();
    this.getEstatuses();
    this.getAgentes();
    this.getCiudades();
    this.selectedHeaders = this.headers;
    this.isCliente = localStorage.getItem("cliente");
}
}
</script>
